import http from "@/utils/http";

// 发送登录验证码
export const sendLoginCode = (params) => http.post('/api/sms.php', params);
// 发送修改手机号验证码
export const sendModifyPasswordCode = (params) => http.get('/api/login/modifyPasswordCode', params);
// 验证码登录
export const loginByCode = (params) => http.post('/api/login/code', params);
// 密码登录
export const loginByPwd = (params) => http.post('/api/login.php', params);
// 注册登录
export const register = (params) => http.post('/api/register.php', params);
// 密码修改
export const modifyPassword= (params) => http.post('/api/up01.php', params);
// 上传图片
export const uploadImg= (params) => http.upload('/api/upload_Img.php', params);
// 提交表单
export const submitDinfo= (params) => http.post('/api/dinfo.php', params);
// 查询状态
export const queryStatus= (params) => http.get('/api/status.php', params);
// 修改状态
export const modifyStatus= (params) => http.post('/api/status.php', params);
// 获取用户信息
export const getUserInfo= (params) => http.get('/api/getinfo.php', params);
// 发送密码至邮箱
export const sendasswordToMail = (params) => http.post('/api/sendpwdtomail.php', params);